import React from 'react'
import { Stack, Box, Text } from '@chakra-ui/react'
import { JournalTypeTypes, JournalTypeText } from '../../containers/PositionJournals/types'
interface ModalBasicDetailsProps {
  journalType: JournalTypeTypes
  sourceAccount: string
  destinationAccount: string
}

export const ModalBasicDetails = ({ journalType, sourceAccount, destinationAccount }: ModalBasicDetailsProps) => {
  return (
    <Stack spacing={2}>
      <Text as='h3' textStyle='h3' className='test-id-transfer-details-header'>
        Transfer Details
      </Text>
      <Stack spacing={6}>
        <Stack direction='row' w='100%' spacing={4}>
          <Box w='50%' data-testid='transferType'>
            <Text fontWeight='bold'>Transfer Type</Text>
            <Text className='test-id-transfer-type'>Position Journal</Text>
          </Box>
          <Box w='50%' data-testid='journalType'>
            <Text fontWeight='bold'>Journal Type</Text>
            <Text className='test-id-journal-type'>{JournalTypeText[journalType]}</Text>
          </Box>
        </Stack>
        <Stack direction='column' w='100%' spacing={4}>
          <Box w='50%' data-testid='sourceAccount'>
            <Text fontWeight='bold'>Source Account</Text>
            <Text className='test-id-source-account'>{sourceAccount}</Text>
          </Box>
          <Box w='50%' data-testid='destinationAccount'>
            <Text fontWeight='bold'>Destination Account</Text>
            <Text className='test-id-destination-account'>{destinationAccount}</Text>
          </Box>
        </Stack>
      </Stack>
    </Stack>
  )
}
